import React, { useState, useEffect } from 'react';
import { FormGroup, Row, Col } from 'reactstrap';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import ProductListItem from './ProductListItem';
import CustomLoader from './CustomLoader';
import Select from 'react-select';
import { customSelectStyles } from '../scripts/selectStyle';

const productTypes = [
	{ label: 'Современная', value: 0 },
	{ label: 'Классика', value: 1 },
	{ label: 'Неоклассика', value: 2 }
];

// безопасный парсер query string
const parseQuery = (queryString) => {
	const query = {};
	if (!queryString) return query;

	const pairs = (queryString[0] === '?' ? queryString.slice(1) : queryString).split('&');

	for (let i = 0; i < pairs.length; i++) {
		const pair = pairs[i].split('=');
		if (pair[0]) {
			query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
		}
	}

	return query;
};

const fetchOurWorks = async (type) => {
	const data = new FormData();
	data.append('type', type);

	const requestOptions = {
		method: 'POST',
		body: data,
	};

	// обновляем URL без encodeURIComponent (он лишний)
	let newUrl = new URL(window.location);

	if (type !== null && type >= 0) {
		newUrl.searchParams.set('filter', type);
	} else {
		newUrl.searchParams.delete('filter');
	}

	window.history.pushState({ path: newUrl.href }, '', newUrl.href);

	const response = await fetch('api/DataforDB/GetOurWorks', requestOptions);

	if (!response.ok) {
		throw new Error('Произошла ошибка');
	}

	return response.json();
};

export const MyWorks = () => {
	const location = useLocation();

	const initialFilter = parseQuery(location.search).filter;
	const initialValue =
		initialFilter !== undefined ? Number(initialFilter) : -1;

	const [filterType, setFilterType] = useState(initialValue);
	const [typeProduct, setTypeProduct] = useState(null);

	const { data, error, isLoading, refetch } = useQuery(
		['galleryWorks', filterType],
		() => fetchOurWorks(filterType),
		{
			enabled: false,
		}
	);

	useEffect(() => {
		refetch();
	}, [filterType, refetch]);

	const handleFilterChange = (value) => {
		const type = value ? value.value : -1;
		setTypeProduct(value);
		setFilterType(type);
	};

	// безопасный выбор значения для react-select
	const selectedType =
		productTypes.find(x => x.value === filterType) || null;

	if (isLoading) {
		return <CustomLoader visible={true} />;
	}

	if (error) {
		return (
			<div className="alert alert-danger">
				Произошла ошибка при загрузке данных: {error.message}
			</div>
		);
	}

	return (
		<>
			<h1>Наши работы</h1>

			<FormGroup>
				<label>Тип кухни</label>

				<Select
					className={'select-style'}
					value={selectedType}
					options={productTypes}
					getOptionLabel={(x) => x.label}
					getOptionValue={(x) => x.value}
					placeholder="Выберите тип кухни"
					isClearable
					onChange={handleFilterChange}
					styles={customSelectStyles}
				/>
			</FormGroup>

			{data && data.length > 0 ? (
				<Row className="products-area">
					{data.map(p => (
						<Col sm={6} md={4} key={p.id}>
							<ProductListItem product={p} type={1} />
						</Col>
					))}
				</Row>
			) : (
				<FormGroup className="alert alert-primary">
					Не найдено товаров
				</FormGroup>
			)}
		</>
	);
};